module.exports = __webpack_public_path__ + "img/shop-banner.5c837d4d.png";